export default "__VITE_ASSET__CpDCB5LX__"